var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.832633 6.55923C2.75281 10.7398 6.16403 14.0533 10.3986 15.8512L11.0786 16.1542C11.8317 16.4895 12.6789 16.5483 13.471 16.3202C14.2631 16.0921 14.9493 15.5917 15.4086 14.9072L16.2976 13.5832C16.4367 13.3756 16.4931 13.1234 16.4555 12.8763C16.4179 12.6292 16.2892 12.4051 16.0946 12.2482L13.0826 9.81823C12.9777 9.73366 12.8568 9.67116 12.7272 9.63448C12.5975 9.59781 12.4618 9.58771 12.3281 9.6048C12.1945 9.6219 12.0657 9.66582 11.9494 9.73394C11.8332 9.80207 11.7319 9.89298 11.6516 10.0012L10.7196 11.2582C8.32724 10.0767 6.39076 8.13983 5.20963 5.74723L6.46563 4.81523C6.57388 4.73499 6.66479 4.6337 6.73291 4.51745C6.80104 4.4012 6.84496 4.27237 6.86205 4.13872C6.87915 4.00507 6.86905 3.86934 6.83238 3.73968C6.7957 3.61003 6.7332 3.48912 6.64863 3.38423L4.21863 0.372227C4.06173 0.17768 3.83766 0.0489404 3.59057 0.0113674C3.34348 -0.0262056 3.09127 0.0301121 2.88363 0.169227L1.55063 1.06323C0.862033 1.52501 0.359722 2.21624 0.133184 3.01379C-0.0933534 3.81134 -0.0294068 4.66342 0.313633 5.41823L0.832633 6.55923Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.960e3000e3e7db45307cd6012eb086ab.svg";
export { ForwardRef as ReactComponent };